import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../rootReducer";

export const selectLocationsAvailable = createSelector(
    [
        (store: RootState) => store.userProfileLocation.locations,
        (store: RootState) => store.userProfileLocation.searchText,
        (store: RootState) => store.userProfileLocation.createFilters,
        (store: RootState) => store.userProfileLocation.selectedLocations,

    ],
    (locations, searchText, createFilters, selectedLocations) => locations?.filter(
        ({ code, name, organization, partOf, id }) => {
            // Descarta los location que no tengan code XXX-XXX
            if (code?.trim().length != 7) {
                return false;
            }

            // Filtro por nombre y código 
            if (
                searchText
                && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
                && !code?.toLowerCase().includes(searchText?.toLowerCase().trim())
            ) {
                return false;
            }

            // Filtro por organization (Cliente)
            if (createFilters.organization.id && organization?.id !== createFilters.organization.id) {
                return false;
            }

            // Filtro por Área de negocio 
            if (
                createFilters.businessArea.id && partOf?.id !== createFilters.businessArea.id
            ) {
                return false;
            }

            // Descarta los locations que ya están seleccionados o asignados
            if (selectedLocations.find(( { id: selectedLocationId }) => selectedLocationId === id)) {
                return false;
              }
            return true;
        })
);